(
  () => {
    'use strict';
    function e(e, a, t) {
      return function (e = []) {
        console.log(e);
        return window.app.emit('cart:updating'),
        fetch(
          `${ window.Phill.routes.cartAdd }.js`,
          {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: e
            })
          }
        ).then((e => e.json())).then(
          (
            async e => {
              if (e.status) return window.app.emit(['cart:updated',
              'cart:error'], null, e),
              {
                item: e,
                cart: window.app.getState().cart,
                error: e?.description
              };
              const [a,
              t] = await Promise.all(
                [fetch(
                  `${ window.Phill.routes.cart }.js`,
                  {
                    method: 'GET',
                    credentials: 'include'
                  }
                ).then((e => e.json())),
                fetch(
                  `${ window.Phill.routes.cart }?sections=api-cart-items`,
                  {
                    method: 'GET',
                    credentials: 'include'
                  }
                ).then((e => e.json()))]
              );
              return a.sections = t,
              window.app.emit(['cart:updated',
              'cart:render'], {
                cart: a
              }),
              {
                item: e,
                cart: a
              }
            }
          )
        )
      }([{
        id: e,
        quantity: a,
        properties: t
      }
      ])
    }
    window.addProductToCart = e;
    function a(e = document.body, a = 'js-') {
      const t = [
        ...e.querySelectorAll(a ? `[class*="${ a }"]` : '*')
      ],
      s = a ? 'classList' : 'dataset';
      return t.reduce(
        (
          (e, t) => (
            [].slice.call(a ? t[s] : Object.entries(t[s])).forEach(
              (
                s => {
                  let c;
                  a &&
                  s.slice(0, a.length) === a ? c = s.slice(a.length, s.length) : a ||
                  ([c] = s),
                  c &&
                  (
                    e[c] = e.hasOwnProperty(c) ? e[c].constructor === Array ? e[c].concat(t) : [
                      e[c],
                      t
                    ] : t
                  )
                }
              )
            ),
            e
          )
        ),
        {
        }
      )
    }
    const t = {
      accessoryProductCard: window.component(
        (
          (t, s) => {
            const {
              accessoryProductJson: c,
              accessoryProductImage: o,
              accessoryColorName: r,
              accessoryColorSwatch: n,
              accessoryPrice: i,
              accessoryStockIndicatorColor: d,
              accessoryStockIndicatorSpan: l,
              accessoryAtcButton: u
            }
            = a(t, null),
            p = [].concat(o),
            m = [].concat(n),
            w = [].concat(i),
            h = JSON.parse(c.innerHTML),
            {
              accessoryVariants: v
            }
            = h;
            let {
              currentAccessoryVariant: g
            }
            = h,
            {
              cartItems: L
            }
            = JSON.parse(document.querySelector('.js-product-json').innerHTML);
            const f = e => {
              u.classList.remove('sold-out', 'available', 'in-cart', 'loading'),
              e ? (u.classList.add('in-cart'), u.disabled = !0) : g.available ? (u.classList.add('available'), u.disabled = !1) : (u.classList.add('sold-out'), u.disabled = !0)
            };
            console.log(f);
            s.on(
              'cart:updated',
              (
                ({
                  cart: e
                }) => {
                  L = e?.items;
                  const a = !!L.find((e => e.variant_id === g.id));
                  // f(a)
                }
              )
            ),
            s.on(
              'variant:change',
              (
                (e, a) => {
                  const t = a.option1.toLowerCase().replace(/ /g, '-');
                  g = v.find((e => e.option1.toLowerCase().replace(/ /g, '-') === t)) ||
                  v[0];
                  const s = !!L.find((e => e.variant_id === g.id));
                  let img_found = false;
                  function ir() {
                    if (img_found == false && p[0]) {
                      p[0].classList.remove('hidden');
                    }
                  }
                  p.forEach(
                    (
                      e => {
                        if (e) {
                          const {
                            variantHandle: a
                          }
                          = e.dataset;
                          if (a === t) { img_found = true; }
                          e.classList[a === t ? 'remove' : 'add']('hidden')
                        }
                      }
                    )
                  ),
                  f(s),
                  ir(),
                  r &&
                  (r.innerText = g.option1),
                  m.forEach(
                    (
                      e => {
                        if (e) {
                          const a = parseInt(e.dataset.variantId, 10);
                          e.classList[a === g.id ? 'add' : 'remove']('color-active')
                        }
                      }
                    )
                  ),
                  w.forEach(
                    (
                      e => {
                        e.innerText = function (e, a = window.Phill.money_format) {
                          'string' == typeof e &&
                          (e = e.replace('.', ''));
                          let t = '';
                          const s = /\{\{\s*(\w+)\s*\}\}/;
                          function c(e, a, t, s) {
                            if (
                              void 0 === a &&
                              (a = 2),
                              s = ',' == (t = window.Phill.money_separator) ? '.' : ',',
                              isNaN(e) ||
                              null == e
                            ) return 0;
                            const c = (e = (e / 100).toFixed(a)).split('.');
                            return c[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (c[1] ? s + c[1] : '')
                          }
                          switch (a.match(s) [1]) {
                            case 'amount':
                            case 'amount_with_comma_separator':
                            case 'amount_with_space_separator':
                              t = c(e, 2);
                              break;
                            case 'amount_no_decimals':
                            case 'amount_no_decimals_with_comma_separator':
                            case 'amount_no_decimals_with_space_separator':
                              t = c(e, 0)
                          }
                          return a.replace(s, t)
                        }(g.price),
                        e.classList[g.available ? 'remove' : 'add']('sold-out')
                      }
                    )
                  ),
                  d.classList[g.available ? 'remove' : 'add']('sold-out'),
                  l.innerText = (
                    (e, a = null) => {
                      let t = e.split('.').reduce(((e, a) => e?.[a]), window?.Phill?.theme?.strings);
                      return t ? (
                        a &&
                        (
                          t = Object.entries(a).reduce(
                            (
                              (e, [
                                a,
                                t
                              ]) => {
                                const s = new RegExp(`\{{2}\s*(${ a })\s*\}{2}`, 'g');
                                return e.replace(s, t)
                              }
                            ),
                            t
                          )
                        ),
                        t
                      ) : `Missing translation for ${ e } in window.Phill`
                    }
                  ) (g.available ? 'product.in_stock' : 'product.sold_out')
                }
              )
            )
          }
        )
      ),
      accessoriesDrawer: window.component(
        (
          (t, s) => {
            const {
              accessoriesDrawerOverlay: c,
              accessoriesDrawer: o,
              accessoriesDrawerProductImage: r,
              openCartButton: n,
              accessoriesBundleJson: i,
              accessoriesBundleAtcButton: d
            }
            = a(t, null),
            l = [].concat(r),
            {
              accessoriesBundleVariantId: u,
              accessoriesBundle: p
            }
            = JSON.parse(i?.innerHTML || '{}');
            n.addEventListener(
              'click',
              (
                () => {
                  s.emit('accessories-drawer:toggle', {
                    drawerOpen: !1
                  }),
                  setTimeout((() => {
                    s.emit('cart:toggle', {
                      cartOpen: !0
                    })
                  }), 300)
                }
              )
            ),
            c.addEventListener(
              'click',
              (() => {
                s.emit('accessories-drawer:toggle', {
                  drawerOpen: !1
                })
              })
            ),
            s.on(
              'accessories-drawer:toggle',
              (
                ({
                  drawerOpen: e
                }) => {
                  o.classList[e ? 'add' : 'remove']('open'),
                  c.classList[e ? 'add' : 'remove']('open')
                }
              )
            ),
            s.on(
              'variant:change',
              (
                (e, a) => {
                  const t = a.option1.toLowerCase().replace(/ /g, '-');
                  l.forEach(
                    (
                      e => {
                        if (e) {
                          const {
                            variantHandle: a
                          }
                          = e.dataset;
                          e.classList[a === t ? 'remove' : 'add']('hidden')
                        }
                      }
                    )
                  )
                }
              )
            ),
            d &&
            (
              s.on(
                'cart:updated',
                (
                  ({
                    cart: e
                  }) => {
                    const a = !!e.items.find((e => e.variant_id === u));
                    d.classList.remove('sold-out', 'available', 'loading', 'in-cart'),
                    a ? (d.classList.add('in-cart'), d.disabled = !0) : p.available ? (d.classList.add('available'), d.disabled = !1) : (d.classList.add('sold-out'), d.disabled = !0)
                  }
                )
              ),
              d.addEventListener(
                'click',
                (
                  () => {
                    d.disabled = !0,
                    d.classList.remove('sold-out', 'available', 'in-cart'),
                    d.classList.add('loading'),
                    e(u, 1)
                  }
                )
              )
            )
          }
        )
      )
    };
    
    window.app.add(t),
    window.app.mount()
  }
) ();
